import { mainFetch } from "../mainFetch"

const SERVICE_URL = '/warehouse/entries'

const fetchService = async ({ url, ...params }) =>
    await mainFetch({ url: SERVICE_URL + url, ...params })
        .catch(e => { console.log(e); throw (e) });

export default class EntriesApi {

    static async getAllEntries({ data = { status: undefined, reason: undefined, skladName: undefined }, ...params }) {
        return await fetchService({ url: '/getallentries', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async deleteEntry({ data = { entryId: undefined }, ...params }) {
        return await fetchService({ url: '/deleteentry', method: 'DELETE', data, ...params })
    }

    // static async changeEntry({ data = { entryId: undefined, field: undefined, value: undefined }, ...params }) {
    //     return await fetchService({ url: '/changeentry', method: 'PATCH', data, ...params })
    // }

    static async confirmEntry({ data = { entryId: undefined }, ...params }) {
        return await fetchService({ url: '/confirmentry', method: 'POST', data, ...params })
    }

    static async closeEntry({ data = { entryId: undefined }, ...params }) {
        return await fetchService({ url: '/closeentry', method: 'POST', data, ...params })
    }



    static async getEntriedProducts({ data = { entryIds: 'Array', tab: undefined, providerId: undefined, search: undefined, filters: undefined, period: undefined, limit: undefined, page: undefined }, ...params }) {
        return await fetchService({ url: '/getentry', method: 'POST', data, notify: { success: false }, ...params })
    }

    // static async changeEntriedProduct({ data = { entryProductId: undefined, field: undefined, value: undefined, action: undefined, reason: undefined }, ...params }) {
    //     return await fetchService({ url: '/changeentriedproduct', method: 'PATCH', data, ...params })
    // }





    static async reportEntries({ data = { entryIds: 'Array', typeFormat: undefined, operation_1c: undefined, tab: undefined, providerId: undefined, search: undefined, filters: undefined, period: undefined, limit: undefined, page: undefined }, ...params }) {
        return await fetchService({ url: '/reportentries', method: 'POST', data, options: { download: true }, ...params })
    }

    static async excelEntries({ data = { entryIds: 'Array', tab: undefined, providerId: undefined, search: undefined, filters: undefined, period: undefined, limit: undefined, page: undefined }, ...params }) {
        return await fetchService({ url: '/excelentries', method: 'POST', data, options: { download: true }, ...params })
    }



}